var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoomSingle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.0284 6C2.90815 6 2 6.89543 2 8V17C2 18.1046 2.90815 19 4.0284 19H16.3083C16.9623 19 17.5762 18.689 17.9571 18.1648L21.6205 13.1233C22.1741 12.3614 22.1168 11.3225 21.4826 10.6242L17.8871 6.66571C17.5023 6.24209 16.9528 6 16.3761 6H4.0284ZM4.0284 17L4.0284 8H16.3761L19.9716 11.9585L16.3083 17H4.0284ZM16.1988 13C16.7589 13 17.213 12.5523 17.213 12C17.213 11.4477 16.7589 11 16.1988 11C15.6387 11 15.1846 11.4477 15.1846 12C15.1846 12.5523 15.6387 13 16.1988 13Z",
    fill: "#009AE9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomSingle);
export default __webpack_public_path__ + "static/media/room-single.f5867817de69defba6cc657200866bb0.svg";
export { ForwardRef as ReactComponent };